/**
 * zh-CN locale — Chinese (Simplified, mainland)
 *
 * Extracted from all frontend source files (Issue #18 — i18n).
 * Falls back to pt-BR for any missing key.
 */
export const zhCN: Record<string, string> = {
  // ---------------------------------------------------------------------------
  // common — shared strings used across multiple pages/components
  // ---------------------------------------------------------------------------
  'common.loading': '加载中...',
  'common.checkSpam': '如果几分钟后仍未收到，请检查垃圾邮件文件夹。',
  'common.checkSpamThirdParty': '如果几分钟后仍未收到，请提醒对方检查垃圾邮件文件夹。',
  'common.close': '关闭',
  'common.cancel': '取消',
  'common.filter': '筛选',
  'common.from': '从',
  'common.to': '到',
  'common.all': '全部',
  'common.type': '类型',
  'common.status': '状态',
  'common.origin': '来源',
  'common.date': '日期',
  'common.file': '文件',
  'common.value': '值',
  'common.confidence': '置信度',
  'common.source': '来源',
  'common.field': '字段',
  'common.yes': '是',
  'common.no': '否',
  'common.email': '电子邮件',
  'common.processing': '处理中...',
  'common.error': '错误',
  'common.dash': '—',
  'common.filterPlaceholder': '筛选...',
  'common.importId': 'Import ID',
  'common.corrected': '已更正',
  'common.errorPrefix': '错误：',

  // Document type labels
  'common.doctype.nfe': 'NF-e',
  'common.doctype.nfse': 'NFS-e',
  'common.doctype.nfcom': 'NFCom',
  'common.doctype.email': '电子邮件',
  'common.doctype.zip': 'ZIP',
  'common.doctype.unknown': '未知',

  // Legal document labels
  'common.legal.terms': '使用条款',
  'common.legal.privacy': '隐私政策',
  'common.legal.cookies': 'Cookie 政策',
  'common.legal.termsShort': '条款',
  'common.legal.privacyShort': '隐私',
  'common.legal.cookiesShort': 'Cookie',
  'common.legal.custodia': '证书保管条款',
  'common.legal.back': '返回',

  // ---------------------------------------------------------------------------
  // app — App.tsx
  // ---------------------------------------------------------------------------
  'app.loading': '加载中...',

  // ---------------------------------------------------------------------------
  // home — Home.tsx
  // ---------------------------------------------------------------------------
  'home.title': 'Aura Nota',
  'home.subtitle': '巴西税务发票（NFS-e、NF-e 和电信）的采集和结构化提取工具。',
  'home.card.upload.title': '上传',
  'home.card.upload.desc': '接收 PDF、XML 和文档图像。',
  'home.card.extraction.title': '提取',
  'home.card.extraction.desc': '使用 OCR、XML 和 LLM 自动读取字段。',
  'home.card.review.title': '审核',
  'home.card.review.desc': '人工界面用于验证和更正数据。',
  'home.hero.title': 'Aura Nota — 智能税务发票采集与提取',
  'home.hero.subtitle': '使用 AI 自动读取 NFS-e、NFCom 和收据。在几秒钟内提取、验证和导出税务字段。',
  'home.hero.cta.signup': '免费开始',
  'home.hero.cta.pricing': '查看方案',
  'home.features.title': '功能',
  'home.features.extraction.title': '自动提取',
  'home.features.extraction.desc': '使用 AI 在几秒钟内提取税务字段',
  'home.features.lgpd.title': 'LGPD 合规',
  'home.features.lgpd.desc': '服务器位于欧盟并签署 DPA，传输与静态加密，内置 DSAR 与同意管理',
  'home.features.multilayout.title': '多版式',
  'home.features.multilayout.desc': 'NFS-e、NFCom、收据等',
  'home.features.export.title': '结构化导出',
  'home.features.export.desc': 'JSON、CSV 及与您的 ERP 集成',
  'home.pricing.teaser.title': '方案从 R$ 0 起',
  'home.pricing.teaser.desc': '免费开始，按需扩展。无需信用卡。',
  'home.pricing.teaser.cta': '查看方案',
  'home.footer.login': '登录',
  'home.footer.signup': '注册',
  'home.footer.pricing': '方案',
  'home.footer.dsar': 'DSAR',
  'home.footer.terms': '条款',
  'home.footer.privacy': '隐私',
  // Issue #594: 公开落地页板块（访客）。
  'home.howItWorks.title': '工作原理',
  'home.howItWorks.step1.title': '发送您的发票',
  'home.howItWorks.step1.desc': '将单据转发到您的专属采集邮箱，或手动上传 PDF、XML 和图片。',
  'home.howItWorks.step2.title': '自动提取',
  'home.howItWorks.step2.desc': 'XML 直接读取；PDF 和图片通过 OCR 与 AI 提取税务字段。',
  'home.howItWorks.step3.title': '安全复核',
  'home.howItWorks.step3.desc': '低置信度字段进入复核队列——每次更正都会记录在审计轨迹中。',
  'home.howItWorks.step4.title': '导出到您的 ERP',
  'home.howItWorks.step4.desc': '下载 JSON 或 CSV 结构化数据，发送给您的会计系统或会计师。',
  'home.captures.title': '我们采集什么',
  'home.captures.nfse.title': 'NFS-e',
  'home.captures.nfse.desc': '支持各种市政布局和服务商的 PDF 与 XML 服务发票。',
  'home.captures.nfcom.title': 'NFCom / NFT（62 型）',
  'home.captures.nfcom.desc': '电信运营商账单，为各大运营商提供专用模板，另有通用布局。',
  'home.captures.nfe.title': 'NF-e 与 NFC-e',
  'home.captures.nfe.desc': '直接读取商品发票和电子小票的 XML，无需 OCR。',
  'home.captures.others.title': '收据、ZIP 与电子邮件',
  'home.captures.others.desc': '收据和扫描件经 OCR/AI 处理，还支持 ZIP 文件和电子邮件（.eml）中的附件。',
  'home.personas.title': '适用对象',
  'home.personas.company.title': '企业',
  'home.personas.company.desc': '财务团队将发票转发至采集邮箱，并把整理好的数据导出到 ERP 或交给会计师。',
  'home.personas.accounting.title': '会计事务所',
  'home.personas.accounting.desc': 'Team 套餐最多 5 个用户，含会计师角色，文档按客户分开。',
  'home.personas.dev.title': '开发者',
  'home.personas.dev.desc': '通过 API 将采集能力集成到您的系统——Enterprise 套餐提供，需联系咨询。',
  'home.diff.title': '产品优势',
  'home.diff.dedup.title': '自动去重',
  'home.diff.dedup.desc': '同一张发票不会重复录入：通过文件哈希和 NF 访问键检测重复。',
  'home.diff.audit.title': '审计轨迹',
  'home.diff.audit.desc': '对单据的每项操作都有记录——谁做的、何时、为何（LGPD）。',
  'home.faq.title': '常见问题',
  'home.faq.q1': 'Aura Nota 处理哪些类型的单据？',
  'home.faq.a1': 'NFS-e（多种市政布局的 PDF 和 XML）、NFCom/NFT 62 型账单、NF-e 与 NFC-e XML、收据及其他 PDF 或图片（经 OCR）。也接受 ZIP 文件和带附件的电子邮件。',
  'home.faq.q2': '专属邮箱采集如何工作？',
  'home.faq.a2': '每个组织都有一个专属采集地址。只需转发带发票附件的邮件——它们会自动进入处理队列。',
  'home.faq.q3': '你们会保留原始文件吗？',
  'home.faq.a3': '不会。文件处理后即被丢弃；我们仅保留提取的数据和元数据，期限为您组织的可配置保留期（默认：5 年）。',
  'home.faq.q4': '开始使用时需要信用卡吗？',
  'home.faq.a4': '不需要。Free 套餐每月包含 10 份文档，无需信用卡。需要更多额度或用户时再升级。',
  'home.faq.q5': '我可以随时取消吗？',
  'home.faq.a5': '可以。取消在已付费周期结束时生效——无即时扣费，也无违约金。',
  'home.faq.q6': '我的数据托管在哪里？',
  'home.faq.a6': '位于欧盟（法国）的服务器，签署数据处理协议（DPA）和标准合同条款，符合 LGPD。详情请见隐私政策。',
  'home.pricing.teaser.ctaSignup': '免费创建账户',

  // ---------------------------------------------------------------------------
  // login — Login.tsx
  // ---------------------------------------------------------------------------
  'login.title': '登录',
  'login.subtitle': '访问您的 Aura Nota 账户。',
  'login.email': '电子邮件',
  'login.password': '密码',
  'login.submit': '登录',
  'login.submitting': '登录中...',
  'login.noAccount': '还没有账户？',
  'login.signupLink': '注册',
  'login.error.auth': '认证错误。',
  'session.expired': '您的会话已过期，请重新登录。',
  'session.loginAgain': '重新登录',

  // ---------------------------------------------------------------------------
  // layout — Layout.tsx
  // ---------------------------------------------------------------------------
  'layout.brand': 'Aura Nota',
  'layout.nav.home': '首页',
  'layout.nav.upload': '上传',
  'layout.nav.documents': '文档',
  'layout.nav.billing': '账单',
  'layout.nav.quota': '配额',
  'layout.nav.subscription': '订阅',
  'layout.nav.myAccount': '我的账户',
  'layout.account': '账户',
  'layout.logout': '退出',
  'layout.login': '登录',
  'layout.footer.terms': '使用条款',
  'layout.footer.privacy': '隐私政策',
  'layout.footer.cookies': 'Cookie 政策',
  'layout.footer.tagline': 'Aura Nota · 税务发票采集和提取',

  // ---------------------------------------------------------------------------
  // consent — ConsentGate.tsx
  // ---------------------------------------------------------------------------
  'consent.title': 'LGPD 同意',
  'consent.intro': '要继续使用 Aura Nota，您必须接受以下法律文件的当前版本（{version}）：',
  'consent.acceptLabel': '我已阅读并接受使用条款、隐私政策和 Cookie 政策。',
  'consent.submit': '接受并继续',
  'consent.submitting': '记录中...',
  'consent.error.check': '检查同意状态时出错。',
  'consent.error.mustAccept': '您必须接受法律文件才能继续。',
  'consent.error.register': '记录同意时出错。',

  // ---------------------------------------------------------------------------
  // errorBoundary — ErrorBoundary.tsx
  // ---------------------------------------------------------------------------
  'errorBoundary.title': '出了点问题',
  'errorBoundary.message': '发生了意外错误。请尝试重新加载页面。',
  'errorBoundary.reload': '重新加载',

  // ---------------------------------------------------------------------------
  // account — Account.tsx
  // ---------------------------------------------------------------------------
  'account.title': '我的账户',
  'account.emailLabel': '电子邮件：',
  'account.statusLabel': '状态：',
  'account.statusActive': '活跃',
  'account.statusInactive': '非活跃',
  'account.historyTitle': '同意历史',
  'account.legalDocsIntro': '当前法律文件：',
  'account.loading': '加载中...',
  'account.error.load': '加载历史时出错。',
  'account.empty': '未记录任何同意。',
  'account.col.document': '文件',
  'account.col.version': '版本',
  'account.col.accepted': '已接受',
  'account.col.date': '日期',
  'account.col.ip': 'IP',
  // 个人资料编辑（"我的资料"）+ 修改密码。
  'account.profile.title': '我的资料',
  'account.profile.name': '姓名',
  'account.profile.namePlaceholder': '您的全名',
  'account.profile.nameRequired': '请输入有效的姓名。',
  'account.profile.language': '语言',
  'account.profile.email': '电子邮箱',
  'account.profile.emailNote': '如需更改邮箱，请联系客服/管理员。',
  'account.profile.save': '保存',
  'account.profile.saving': '保存中...',
  'account.profile.saved': '资料更新成功。',
  'account.profile.error': '保存资料时出错。',
  'account.password.title': '修改密码',
  'account.password.current': '当前密码',
  'account.password.new': '新密码',
  'account.password.confirm': '确认新密码',
  'account.password.hint': '至少 8 个字符，包含至少 1 个字母和 1 个数字。',
  'account.password.submit': '修改密码',
  'account.password.submitting': '修改中...',
  'account.password.success': '密码修改成功。',
  'account.password.error': '修改密码时出错。',
  'account.password.mismatch': '确认密码与新密码不一致。',
  'account.password.tooShort': '新密码至少需要 8 个字符。',

  // ---------------------------------------------------------------------------
  // audit — Audit.tsx
  // ---------------------------------------------------------------------------
  'audit.title': 'LGPD 审计',
  'audit.subtitle': '处理、访问和同意事件日志。',
  'audit.exportCsv': '导出 CSV',
  'audit.exportJson': '导出 JSON',
  'audit.compliance.title': 'LGPD 合规',
  'audit.compliance.pii': '匿名化 PII：文件名和哈希值存储时不包含直接个人数据',
  'audit.compliance.retention': '保留：审计日志不可变，按照保留策略维护',
  'audit.compliance.dsar': 'DSAR：数据主体权利（访问、删除、可携带性）可通过 API 使用',
  'audit.filter.eventType': '事件类型',
  'audit.filter.from': '从',
  'audit.filter.to': '到',
  'audit.filter.all': '全部',
  'audit.filter.action.documentUpload': '文档上传',
  'audit.filter.action.documentUploadDuplicate': '重复上传',
  'audit.filter.action.documentProcess': '处理',
  'audit.filter.action.documentDelete': '删除',
  'audit.filter.action.consentAccepted': '同意',
  'audit.filter.action.login': '登录',
  'audit.filter.action.logout': '退出',
  'audit.loading': '加载中...',
  'audit.error.load': '加载审计时出错。',
  'audit.empty': '未找到审计事件。',
  'audit.eventCount': '{count} 个事件',
  'audit.col.date': '日期',
  'audit.col.event': '事件',
  'audit.col.resource': '资源',
  'audit.col.details': '详情',
  'audit.col.user': '用户',
  // Action labels (display in table)
  'audit.action.document_upload': '文档上传',
  'audit.action.document_upload_duplicate': '重复上传',
  'audit.action.document_process': '处理',
  'audit.action.document_delete': '文档删除',
  'audit.action.consent_accepted': '同意已接受',
  'audit.action.login': '登录',
  'audit.action.logout': '退出',

  // ---------------------------------------------------------------------------
  // documents — Documents.tsx
  // ---------------------------------------------------------------------------
  'documents.title': '文档',
  'documents.view.grid': '表格',
  'documents.view.cards': '卡片',
  'documents.export.csv': '导出 CSV',
  'documents.export.excel': '导出 Excel',
  'documents.filter.type': '类型',
  'documents.filter.status': '状态',
  'documents.filter.all': '全部',
  'documents.filter.from': '从',
  'documents.filter.to': '到',
  'documents.filter.importId': 'Import ID',
  'documents.filter.importIdPlaceholder': '例如：20260819-001',
  'documents.filter.button': '筛选',
  'documents.loading': '加载中...',
  'documents.loadingDetails': '加载详情中...',
  'documents.empty': '未找到文档。',
  'documents.error.load': '加载文档时出错。',
  'documents.error.loadDetail': '加载详情时出错。',
  'documents.error.saveField': '保存字段时出错。',
  'documents.error.export': '导出时出错。',

  // Status filter options
  'documents.status.concluido': '已完成',
  'documents.status.revisao': '审核',
  'documents.status.erro': '错误',
  'documents.status.recebido': '已接收',

  // Fiscal column headers (grid)
  'documents.col.numero': '编号',
  'documents.col.serie': '系列',
  'documents.col.prestadorCnpj': '提供方 CNPJ',
  'documents.col.prestadorCnpjEmitente': '开票方CNPJ',
  'documents.col.prestador': '提供方',
  'documents.col.tomadorCnpj': '接收方 CNPJ',
  'documents.col.tomadorCnpjDestinatario': '收票方CNPJ',
  'documents.col.tomador': '接收方',
  'documents.col.valorTotal': '总值',
  'documents.col.valorServico': '服务值',
  'documents.col.dataEmissao': '开具日期',
  'documents.col.municipio': '市镇',
  'documents.col.codVerificacao': '验证码',
  'documents.col.descricao': '描述',
  'documents.col.imPrestador': '提供方 IM',
  'documents.col.docType': '文档类型',
  'documents.col.importId': 'Import ID',
  'documents.col.origin': '来源',

  // Cards view headers
  'documents.cards.importId': 'Import ID',
  'documents.cards.file': '文件',
  'documents.cards.type': '类型',
  'documents.cards.status': '状态',
  'documents.cards.fields': '字段',
  'documents.cards.confidence': '置信度',
  'documents.cards.children': '子项',
  'documents.cards.date': '上传',

  // Detail panel
  'documents.detail.close': '关闭',
  'documents.detail.downloading': '下载中...',
  'documents.detail.downloadJson': '下载 JSON',
  'documents.detail.downloadXml': '下载 XML',
  'documents.detail.downloadPdf': '下载 PDF',
  'documents.detail.downloadFields': '下载字段 (CSV)',
  'documents.detail.type': '类型',
  'documents.detail.origin': '来源',
  'documents.detail.status': '状态',
  'documents.detail.avgConfidence': '平均置信度',
  'documents.detail.importId': '导入 ID',
  'documents.detail.needsReview': '需要审核：{reason}',
  'documents.detail.reviewReasonDefault': '未指定原因',
  'documents.detail.error': '错误：{error}',
  'documents.detail.extractedFields': '提取的字段',
  'documents.detail.col.field': '字段',
  'documents.detail.col.value': '值',
  'documents.detail.col.confidence': '置信度',
  'documents.detail.col.origin': '来源',
  'documents.detail.col.raw': 'Raw',
  'documents.detail.metadata': '元数据',
  'documents.detail.children': '子文档（{count}）',
  'documents.detail.childError': '错误',
  'documents.detail.processingLog': '处理审计日志',

  // Editable cell tooltip
  'documents.cell.tooltip': '{field} — 置信度 {conf}%（双击编辑）',

  // Provenance modal
  'documents.provenance.title': '来源链',
  'documents.provenance.close': '关闭',
  'documents.provenance.noChain': '无 container_chain（直接终端文件）。',
  'documents.delete': '删除',
  'documents.deleteConfirm': '确定要将此文档移至回收站吗？您可以在30天内恢复它。',
  'documents.trash': '回收站',
  'documents.restore': '恢复',
  'documents.daysUntilPurge': '距永久删除天数',
  'documents.timeRemaining': '剩余时间：{days}天后永久删除',
  'documents.trashEmpty': '回收站为空。',
  'documents.trashDeletedAt': '删除于',
  'documents.actions': '操作',
  'documents.error.delete': '移入回收站时出错。',
  'documents.error.restore': '恢复文档时出错。',

  // Batch selection (Feature 2)
  'documents.batch.selectedCount': '已选择 {count} 项',
  'documents.batch.selectAll': '全选',
  'documents.batch.deleteTitle': '删除文档',
  'documents.batch.deleteConfirm': '确定要删除 {count} 个文档吗？它们将被移至回收站，可在 30 天内恢复。',
  'documents.batch.deletePartialError': '删除 {total} 个文档中的 {failed} 个时出错。',

  // ---------------------------------------------------------------------------
  // upload — Upload.tsx
  // ---------------------------------------------------------------------------
  'upload.title': '文档上传',
  'upload.subtitle': '发送 PDF、XML、电子邮件（.eml/.msg）、ZIP、HTML 或图像以自动提取税务字段。',
  'upload.dropzone.text': '拖拽文件到此处或点击选择',
  'upload.dropzone.formats': '格式：{formats} — 最大 25 MB',
  'upload.process': '处理（{count} 个待处理）',
  'upload.processing': '处理中...',
  'upload.clear': '清除',
  'upload.summary': '{done} 已完成，{errors} 个错误，{pending} 个待处理',
  'upload.filesTitle': '已上传文件',
  'upload.viewResult': '查看结果',
  'upload.remove': '移除',
  'upload.result.type': '类型：{type}',
  'upload.result.origin': '来源：{origin}',
  'upload.result.fields': '字段：{count}',
  'upload.result.errors': '错误：{count}',
  'upload.result.duplicate': '重复',
  'upload.error.batchNotFound': '批次中未找到结果。',
  'upload.error.cancelledDuplicate': '已取消（重复未处理）',
  'upload.error.timeout': '等待处理超时。',
  // Issue #279: 3+ 文件批量上传模式。
  'upload.batch.submitted': '批次已发送。完成后将通知您。',
  'upload.batch.inProgress': '批次处理中：{done}/{total} 已完成',
  'upload.batch.complete': '批次完成：{success} 成功，{errors} 错误',
  'upload.batch.blocked': '请等待当前批次完成',
  'upload.batch.networkError': '批次可能仍在服务器上处理。请先查看文档列表再重新发送。',
  'upload.batch.checkStatus': '查看状态',

  // Status badge labels
  'upload.status.pending': '待处理',
  'upload.status.uploading': '上传中...',
  'upload.status.processing': '处理中...',
  'upload.status.done': '已完成',
  'upload.status.error': '错误',

  // Result panel
  'upload.result.title': '提取结果',
  'upload.result.close': '关闭',
  'upload.result.file': '文件',
  'upload.result.typeLabel': '类型',
  'upload.result.originLabel': '来源',
  'upload.result.time': '耗时',
  'upload.result.needsReview': '需要审核：{reason}',
  'upload.result.reviewReasonDefault': '未指定原因',
  'upload.result.error': '错误：{error}',
  'upload.result.extractedFields': '提取的字段',
  'upload.result.col.field': '字段',
  'upload.result.col.value': '值',
  'upload.result.col.confidence': '置信度',
  'upload.result.col.origin': '来源',
  'upload.result.metadata': '元数据',
  'upload.result.children': '子文档（{count}）',
  'upload.result.childError': '错误',

  // Duplicate modal (single file)
  'upload.duplicate.title': '检测到重复 NF',
  'upload.duplicate.intro': '此 NF 之前已被处理过。',
  'upload.duplicate.type.file': '相同文件',
  'upload.duplicate.type.data': '相同 NF（数据）',
  'upload.duplicate.importId': 'Import ID',
  'upload.duplicate.type': '类型',
  'upload.duplicate.file': '文件',
  'upload.duplicate.processedAt': '处理时间',
  'upload.duplicate.whatToDo': '您想怎么做？',
  'upload.duplicate.replace': '替换',
  'upload.duplicate.replaceDesc': '删除之前的记录并创建新记录',
  'upload.duplicate.archive': '归档',
  'upload.duplicate.archiveDesc': '保留之前的记录归档并创建新记录',
  'upload.duplicate.duplicate': '重复',
  'upload.duplicate.duplicateDesc': '创建新记录而不更改之前的记录',
  'upload.duplicate.cancel': '取消',
  'upload.duplicate.cancelDesc': '不处理',
  'upload.duplicate.processing': '处理中...',

  // Batch duplicate modal
  'upload.batchDuplicate.title': '找到 {count} 个重复文件',
  'upload.batchDuplicate.intro': '以下文件之前已被处理过。请为每个文件选择操作。非重复文件将正常处理。',
  'upload.batchDuplicate.type.file': '相同文件',
  'upload.batchDuplicate.type.data': '相同 NF（数据）',
  'upload.batchDuplicate.existingImportId': '现有 Import ID',
  'upload.batchDuplicate.existingFile': '现有文件',
  'upload.batchDuplicate.processedAt': '处理时间',
  'upload.batchDuplicate.replace': '替换',
  'upload.batchDuplicate.replaceDesc': '删除之前的并创建新的',
  'upload.batchDuplicate.archive': '归档',
  'upload.batchDuplicate.archiveDesc': '归档之前的并创建新的',
  'upload.batchDuplicate.duplicate': '重复',
  'upload.batchDuplicate.duplicateDesc': '创建新的而不更改之前的',
  'upload.batchDuplicate.remove': '移除',
  'upload.batchDuplicate.removeDesc': '删除之前的记录（管理员）',
  'upload.batchDuplicate.cancel': '取消',
  'upload.batchDuplicate.cancelDesc': '不处理',
  'upload.batchDuplicate.cancelAll': '全部取消',
  'upload.batchDuplicate.confirm': '确认决定',
  'upload.batchDuplicate.processing': '处理中...',

  // Notifications (Issue #281)
  'notifications.title': '通知',
  'notifications.empty': '没有通知',
  'notifications.markAllRead': '全部标记为已读',
  'notifications.batchComplete': '批次完成',
  'notifications.justNow': '刚刚',
  'notifications.minutesAgo': '{n} 分钟前',
  'notifications.hoursAgo': '{n} 小时前',
  'notifications.daysAgo': '{n} 天前',
  // Sprint 7: Billing / Pricing / Signup

  'layout.nav.pricing': '套餐',
  'pricing.title': '选择适合您的套餐',
  'pricing.subtitle': '免费开始，按需升级。无需信用卡。',
  'pricing.unlimited': '联系我们',
  'pricing.free': '免费',
  'pricing.month': '月',
  'pricing.unlimitedDocs': '无限文档',
  'pricing.docsPerMonth': '每月 {count} 份文档',
  'pricing.popular': '最受欢迎',
  'pricing.feat.upload': '文档上传',
  'pricing.feat.exportCsv': '导出 CSV',
  'pricing.feat.multiUser': '多用户',
  'pricing.feat.audit': '审计日志',
  'pricing.feat.apiAccess': 'API 访问',
  'pricing.feat.prioritySupport': '优先支持',
  'pricing.ctaFree': '免费开始',
  'pricing.ctaPaid': '订阅',
  'pricing.processing': '处理中...',
  'pricing.pixTitle': '通过 PIX 支付',
  'pricing.pixInstructions': '使用您的银行应用扫描下方二维码支付订阅费用。',
  'pricing.goToBilling': '前往账单',
  // Issue #593: Single/Team/Enterprise 套餐（#592 契约）+ 同页对比表。
  'pricing.ctaEnterprise': '联系销售',
  'pricing.enterpriseMailSubject': 'Aura Nota — Enterprise 套餐',
  'pricing.users.one': '1 个用户',
  'pricing.users.upTo': '最多 {count} 个用户',
  'pricing.users.unlimited': '用户不限',
  'pricing.feat.exportJson': '导出 JSON',
  'pricing.feat.emailCapture': '专属邮箱采集',
  'pricing.feat.accountant': '会计师用户',
  'pricing.feat.onboarding': '协助开通',
  'comparison.title': '套餐对比',
  'comparison.subtitle': '所有功能，一目了然。',
  'comparison.feature': '功能',
  'comparison.unlimited': '不限',
  'comparison.row.docs': '每月文档数',
  'comparison.row.users': '包含用户数',
  'comparison.row.accountant': '会计师用户',
  'comparison.row.emailUpload': '专属邮箱采集与手动上传',
  'comparison.row.exportJson': 'JSON 导出',
  'comparison.row.exportCsv': 'CSV 导出',
  'comparison.row.multiUser': '多用户（团队）',
  'comparison.row.audit': '审计轨迹（LGPD）',
  'comparison.row.apiAccess': 'API 访问',
  'comparison.row.prioritySupport': '优先支持',
  'comparison.row.onboarding': '协助开通',
  'signup.title': '创建账户',
  'signup.subtitle': '免费开始使用 Aura Nota。',
  'signup.name': '姓名',
  'signup.company': '公司',
  'signup.email': '电子邮件',
  'signup.password': '密码',
  'signup.passwordHint': '至少 8 个字符，1 个字母和 1 个数字。',
  'signup.submit': '创建账户',
  'signup.submitting': '创建中...',
  'signup.error': '无法创建账户。',
  'signup.haveAccount': '已有账户？',
  'signup.loginLink': '登录',
  'signup.successTitle': '账户已创建！',
  'signup.successBody': '请检查您的电子邮件以激活账户。激活后，您可以登录。',
  'signup.goLogin': '前往登录',
  'billing.title': '账单',
  'billing.currentPlan': '当前套餐',
  'billing.planLabel': '套餐',
  'billing.statusLabel': '状态',
  'billing.status.active': '活跃',
  'billing.status.pending_payment': '待付款',
  'billing.status.suspended': '已暂停',
  'billing.status.cancelled': '已取消',
  'billing.renewsOn': '续订于',
  'billing.paymentMethod': '付款方式',
  'billing.usage': '本月使用量',
  'billing.used': '{used} / {limit} 份文档',
  'billing.remaining': '剩余 {count}',
  'billing.unlimited': '无限',
  'billing.resetsOn': '于 {date} 重置',
  'billing.pendingPayment': '待付款',
  'billing.invoiceAmount': 'R$ {amount}',
  'billing.dueDate': '到期日：{date}',
  'billing.pixTitle': '通过 PIX 支付',
  'billing.pixInstructions': '使用您的银行扫描二维码。付款后，管理员将确认并激活您的套餐。',
  'billing.invoiceId': '发票：{id}',
  'billing.refresh': '刷新',
  'billing.upgradePro': '升级到 Pro',
  'billing.viewPlans': '查看套餐并升级',
  'billing.cancel': '取消订阅',
  'billing.cancelConfirm': '您确定要取消订阅吗？',
  'billing.processing': '处理中...',
  'signup.consentPrefix': '我已阅读并同意',
  'signup.consentAnd': '和',
  'signup.consentRequired': '您必须接受使用条款和隐私政策才能创建账户。',

  'layout.nav.sefaz': '按密钥搜索',
  'sefaz.title': '按访问密钥搜索 NF-e',
  'sefaz.tab.individual': '单个',
  'sefaz.tab.batch': '批量 (Excel)',
  'sefaz.individual.label': '访问密钥 (44位数字)',
  'sefaz.individual.invalid': '密钥无效：必须有44位数字及有效校验位',
  'sefaz.individual.valid': '密钥有效',
  'sefaz.individual.search': '搜索',
  'sefaz.individual.result': '搜索结果',
  'sefaz.individual.goToDocs': '在文档中查看',
  'sefaz.status': '状态',
  'sefaz.batch.downloadTemplate': '下载Excel模板',
  'sefaz.batch.dropHere': '拖拽.xlsx文件到此处或点击选择',
  'sefaz.batch.errorFormat': '文件必须为.xlsx',
  'sefaz.batch.progress': '批量进度',
  'sefaz.batch.total': '总计',
  'sefaz.batch.processed': '已处理',
  'sefaz.batch.success': '成功',
  'sefaz.batch.error': '错误',
  'sefaz.batch.status': '状态',
  'sefaz.batch.goToDocs': '查看已创建文档',
  'sefaz.batch.history': '历史批次',
  'sefaz.batch.export': '导出结果',
  'layout.nav.sefazGroup': '税务 / SEFAZ',
  'sefaz.nav.status': '服务状态',
  'sefaz.nav.consulta': '按密钥查询',
  'sefaz.nav.dfe': '按 NSU 分发 DF-e',
  'sefaz.nav.certs': '证书',
  'sefaz.statusPage.title': 'SEFAZ 服务状态',
  'sefaz.statusPage.ufLabel': '州 (UF)',
  'sefaz.statusPage.tab.nfe': 'NF-e',
  'sefaz.statusPage.tab.cte': 'CT-e',
  'sefaz.statusPage.tab.mdfe': 'MDF-e',
  'sefaz.statusPage.consult': '查询',
  'sefaz.statusPage.cstat': 'cStat',
  'sefaz.statusPage.xmotivo': '原因',
  'sefaz.statusPage.uf': '州 (UF)',
  'sefaz.statusPage.timestamp': '时间',
  'sefaz.statusPage.rateLimited': '请求次数超限。请在 {s} 秒后重试。',
  'sefaz.statusPage.unavailable': 'SEFAZ 服务暂时不可用。请稍后重试。',
  'sefaz.gated.title': '需要配置 A1 证书',
  'sefaz.gated.body': '此查询需要与组织关联的 A1 数字证书。请在 Fiscal/SEFAZ > 证书 中注册。',
  'sefaz.gated.cta': '前往证书',
  'sefaz.dfe.title': '按 NSU 分发 DF-e',
  'sefaz.dfe.nsuLabel': '最新 NSU（15 位数字）',
  'sefaz.certs.title': 'A1 证书管理',
  'sefaz.certs.badge': '即将推出',
  'sefaz.certs.body': '您将能够在此注册和管理组织的 A1 数字证书，这是进行 SEFAZ 认证查询（按密钥查询和 DF-e 分发）所必需的。',
  // Sprint 14 (issue #482): pagina real de custodia de certificados A1.
  'sefaz.certs.subtitle': '用于 SEFAZ 认证查询的 A1 数字证书（e-CNPJ）。',
  'sefaz.certs.retry': '重试',
  'sefaz.certs.tab.detail': '证书',
  'sefaz.certs.tab.history': '历史记录',
  'sefaz.certs.empty.title': '未注册证书',
  'sefaz.certs.empty.body': '上传组织的 A1 数字证书（.pfx/.p12）以启用 SEFAZ 认证查询。',
  'sefaz.certs.empty.memberHint': '组织尚未注册数字证书。请联系管理员上传。',
  'sefaz.certs.empty.cta': '上传证书',
  'sefaz.certs.member.title': '组织数字证书',
  'sefaz.certs.member.absent': '未注册数字证书。',
  'sefaz.certs.member.configured': '数字证书已配置并处于激活状态。',
  'sefaz.certs.member.expiring': '数字证书将在 {n} 天后过期。',
  'sefaz.certs.member.expired': '数字证书已过期。',
  'sefaz.certs.member.hint': '证书管理仅限组织管理员操作。',
  'sefaz.certs.expiredBanner': '数字证书已过期 — 在轮换之前 SEFAZ 查询不可用。',
  'sefaz.certs.expiredCta': '立即轮换',
  'sefaz.certs.meta.title': '托管证书',
  'sefaz.certs.meta.cn': '名称 (CN)',
  'sefaz.certs.meta.issuer': '颁发者',
  'sefaz.certs.meta.serial': '序列号',
  'sefaz.certs.meta.cnpj': 'CNPJ',
  'sefaz.certs.meta.validFrom': '有效期自',
  'sefaz.certs.meta.validTo': '有效期至',
  'sefaz.certs.meta.fingerprint': 'SHA-256 指纹',
  'sefaz.certs.meta.uploadedAt': '上传时间',
  'sefaz.certs.meta.uploadedBy': '上传者',
  'sefaz.certs.meta.lastSession': '最近 MCP 会话',
  'sefaz.certs.status.ativo': '有效',
  'sefaz.certs.status.ausente': '无证书',
  'sefaz.certs.status.vencendo': '{n} 天后过期',
  'sefaz.certs.status.expirado': '已过期',
  'sefaz.certs.status.pendente': '待同意',
  'sefaz.certs.status.removido': '已移除',
  'sefaz.certs.actions.rotate': '轮换证书',
  'sefaz.certs.actions.remove': '移除证书',
  'sefaz.certs.upload.titleCreate': '上传 A1 证书',
  'sefaz.certs.upload.titleRotate': '轮换 A1 证书',
  'sefaz.certs.upload.dropzone': '将证书文件拖到此处或点击选择',
  'sefaz.certs.upload.formats': '支持格式：.pfx 或 .p12 — 最大 64 KB',
  'sefaz.certs.upload.changeFile': '点击更换文件',
  'sefaz.certs.upload.fileErrorExt': '文件无效：请上传 .pfx 或 .p12 (A1) 证书。',
  'sefaz.certs.upload.fileErrorSize': '文件超过 64 KB 限制。',
  'sefaz.certs.upload.passwordLabel': '证书密码',
  'sefaz.certs.upload.passwordHint': '密码仅用于验证证书并加密存储 — 绝不显示或保存在浏览器中。',
  'sefaz.certs.upload.submitCreate': '验证并托管',
  'sefaz.certs.upload.submitRotate': '验证并轮换',
  'sefaz.certs.upload.successCreate': '证书上传并托管成功。',
  'sefaz.certs.upload.successRotate': '证书轮换成功。',
  'sefaz.certs.consent.text': '我授权 Aura Nota 以加密形式托管组织的 A1 数字证书（CNPJ {cnpj}），仅通过临时会话代表我进行税务查询，并确认我可以随时撤销此授权并移除证书。',
  'sefaz.certs.consent.textNoCnpj': '我授权 Aura Nota 以加密形式托管组织的 A1 数字证书，仅通过临时会话代表我进行税务查询，并确认我可以随时撤销此授权并移除证书。',
  'sefaz.certs.consent.linkLabel': '阅读托管条款',
  'sefaz.certs.mismatch.title': 'CNPJ 不一致',
  'sefaz.certs.mismatch.body': '新证书的 CNPJ 与组织的 CNPJ 不匹配。仅当组织确实更换了 CNPJ 或此证书属于正确的持有者时才确认。',
  'sefaz.certs.mismatch.confirm': '确认不一致并轮换',
  'sefaz.certs.remove.title': '移除证书',
  'sefaz.certs.remove.impact': '影响：在上传新证书之前，此组织的税务查询（SEFAZ/RFB）将不可用。加密材料将立即删除，MCP 会话将关闭。',
  'sefaz.certs.remove.confirmLabel': '我了解影响并确认移除托管的证书。',
  'sefaz.certs.remove.confirm': '永久移除',
  'sefaz.certs.remove.success': '证书已从托管中移除。',
  'sefaz.certs.history.col.action': '操作',
  'sefaz.certs.history.col.user': '用户',
  'sefaz.certs.history.col.timestamp': '日期/时间',
  'sefaz.certs.history.col.ip': 'IP',
  'sefaz.certs.history.empty': '此证书暂无事件记录。',
  'sefaz.certs.history.prev': '上一页',
  'sefaz.certs.history.next': '下一页',
  'sefaz.certs.history.page': '第 {page} 页，共 {pages} 页',
  'sefaz.certs.history.action.cert_upload': '证书上传',
  'sefaz.certs.history.action.cert_view': '元数据查看',
  'sefaz.certs.history.action.cert_rotate': '证书轮换',
  'sefaz.certs.history.action.cert_delete': '证书移除',
  'sefaz.certs.history.action.cert_use': '用于 SEFAZ 查询',
  'sefaz.certs.history.action.cert_consent_grant': '同意已记录',
  'sefaz.certs.history.action.cert_consent_revoke': '同意已撤销',
  'sefaz.certs.history.action.cert_session_open': 'MCP 会话已打开',
  'sefaz.certs.error.invalidPfx': '证书密码错误或文件无效。',
  'sefaz.certs.error.invalidChain': '证书不是 A1 ICP-Brasil（不接受 e-CPF、A3 或自签名证书）。',
  'sefaz.certs.error.expired': '证书已过期 — 请上传有效证书。',
  'sefaz.certs.error.cnpjMismatch': '证书的 CNPJ 与组织的 CNPJ 不匹配。',
  'sefaz.certs.error.rateLimited': '尝试次数超限。请在 {min} 分钟后重试。',
  'sefaz.certs.error.uploadDisabled': '此环境中已禁用证书上传。',
  'sefaz.certs.error.noOrgCnpj': '请在上传证书前注册组织的 CNPJ。',
  'sefaz.certs.error.pfxTooLarge': '证书文件超过允许的大小限制。',
  'sefaz.certs.error.alreadyExists': '已有托管证书 — 请使用轮换进行替换。',
  'sefaz.certs.error.consentRequired': '必须接受托管条款才能继续。',
  'sefaz.certs.error.confirmRequired': '请确认操作以继续。',
  'sefaz.certs.error.unavailable': '税务查询服务不可用。请稍后重试。',
  'sefaz.certs.error.forbidden': '您没有权限执行此操作。',
  'sefaz.certs.error.validation': '证书数据无效。',
  'sefaz.certs.error.generic': '无法完成操作。',

  // catalogo — 协作式城市/提供商目录 (S10-T06)
  'layout.nav.catalogo': '城市目录',
  'catalogo.title': '城市目录',
  'catalogo.subtitle': '协作式城市 → NFS-e 提供商映射。',
  'catalogo.stats.municipios': '已覆盖城市',
  'catalogo.stats.provedores': '支持的提供商',
  'catalogo.stats.ufs': '覆盖州数',
  'catalogo.stats.pendentes': '待审核建议',
  'catalogo.table.title': '城市',
  'catalogo.table.ibge': 'IBGE',
  'catalogo.table.nome': '城市',
  'catalogo.table.uf': '州',
  'catalogo.table.provedor': '提供商',
  'catalogo.table.agregador': '聚合商',
  'catalogo.table.empty': '未找到城市。',
  'catalogo.filter.uf': '州',
  'catalogo.filter.provedor': '提供商',
  'catalogo.filter.busca': '搜索城市',
  'catalogo.export': '导出 JSON',
  'catalogo.import': '导入 JSON',
  'catalogo.import.result': '导入：新建 {created} 条，更新 {updated} 条（共 {total} 条）。',
  'catalogo.suggest.title': '建议映射',
  'catalogo.suggest.ibge': 'IBGE 代码',
  'catalogo.suggest.nome': '城市',
  'catalogo.suggest.uf': '州',
  'catalogo.suggest.provedor': '提供商',
  'catalogo.suggest.agregador': '聚合商（可选）',
  'catalogo.suggest.justificativa': '理由（可选）',
  'catalogo.suggest.submit': '提交建议',
  'catalogo.suggest.success': '建议已提交审核。',
  'catalogo.sugestoes.title': '建议',
  'catalogo.sugestoes.empty': '暂无建议。',
  'catalogo.sugestoes.status.pendente': '待审核',
  'catalogo.sugestoes.status.aprovada': '已批准',
  'catalogo.sugestoes.status.rejeitada': '已拒绝',
  'catalogo.moderation.actions': '操作',
  'catalogo.moderation.approve': '批准',
  'catalogo.moderation.reject': '拒绝',
  'catalogo.moderation.rejectPrompt': '拒绝原因（可选）：',
  'catalogo.history.title': '目录历史',
  'catalogo.history.action': '操作',
  'catalogo.history.action.create': '创建',
  'catalogo.history.action.update': '更新',
  'catalogo.history.action.delete': '删除',
  'catalogo.history.origem.admin': '直接编辑',
  'catalogo.history.origem.sugestao': '已批准建议',
  'catalogo.history.origem.import': '导入',
  'catalogo.history.empty': '暂无变更记录。',
  'catalogo.error.generic': '无法完成操作。',

  // ---------------------------------------------------------------------------
  // onboarding — 租户引导向导（S10-T07, US-S10-007）
  // ---------------------------------------------------------------------------
  'layout.nav.onboarding': '入门引导',
  'onboarding.title': '引导式入门',
  'onboarding.subtitle': '逐步配置组织：电子邮件、城市、阈值和界面导览。',
  'onboarding.progress': '已完成 {done}/{total} 步',
  'onboarding.error.load': '加载入门清单时出错。',
  'onboarding.error.action': '执行操作时出错。',
  'onboarding.step.email': '电子邮件',
  'onboarding.step.municipios': '城市',
  'onboarding.step.thresholds': '阈值',
  'onboarding.step.tour': '界面导览',
  'onboarding.step.auto': '已检测到',
  'onboarding.step.autoHint': '该步骤已由组织当前配置满足。',
  'onboarding.step.complete': '完成此步骤',
  'onboarding.step.completeHint': '只有当相应配置已保存时，才能完成该步骤。',
  'onboarding.step.done': '步骤已完成',
  'onboarding.nav.prev': '上一步',
  'onboarding.nav.next': '下一步',
  'onboarding.finish': '完成入门引导',
  'onboarding.help.title': '帮助',
  'onboarding.help.email': '配置用于自动捕获发票的 IMAP 邮箱和/或发送邮件的 SMTP。入门完成后可在 设置 → 电子邮件 中管理。',
  'onboarding.help.municipios': '选择贵组织接收 NFS-e 的城市。选项来自协作式 城市 → 服务商 目录。',
  'onboarding.help.thresholds': '设置提取验证阈值。之后可在 设置 → 阈值 中调整。',
  'onboarding.help.tour': '导览将展示界面的主要区域。您可以跳过并手动完成该步骤。',
  'onboarding.help.link.settingsEmail': '打开设置',
  'onboarding.help.link.settingsThresholds': '打开设置',
  'onboarding.help.link.catalogo': '打开城市目录',
  'onboarding.email.title': '电子邮件（捕获与发送）',
  'onboarding.email.subtitle': '配置受监控的 IMAP 邮箱和/或组织的 SMTP 服务器，并提供连接测试。',
  'onboarding.email.imapDetected': 'IMAP 已配置',
  'onboarding.email.smtpDetected': 'SMTP 已配置',
  'onboarding.email.imapLegend': 'IMAP — 发票捕获',
  'onboarding.email.imapHint': '用于自动捕获 NFS-e/账单的受监控邮箱。',
  'onboarding.email.smtpLegend': 'SMTP — 邮件发送',
  'onboarding.email.smtpHint': '用于发送邀请和通知的 SMTP 服务器。',
  'onboarding.email.saveImap': '保存并测试 IMAP',
  'onboarding.email.imapSaved': 'IMAP 已保存。',
  'onboarding.email.saveSmtp': '保存 SMTP',
  'onboarding.email.smtpSaved': 'SMTP 已保存。',
  'onboarding.email.testSmtp': '测试 SMTP 连接',
  'onboarding.email.testOk': '连接测试：{message}',
  'onboarding.email.testFail': '测试失败：{error}',
  'onboarding.email.tip.host': '邮件服务器地址（例如 imap.example.com 或 smtp.example.com）。',
  'onboarding.email.tip.password': '邮箱密码或应用专用密码。加密存储。',
  'onboarding.email.tip.testSmtp': '请先保存 SMTP 再测试 —— 测试使用已持久化的配置。',
  'onboarding.municipios.title': '受监控城市',
  'onboarding.municipios.subtitle': '从目录中选择贵组织接收 NFS-e 的城市。',
  'onboarding.municipios.searchPlaceholder': '按名称搜索城市…',
  'onboarding.municipios.search': '搜索',
  'onboarding.municipios.searching': '搜索中…',
  'onboarding.municipios.empty': '目录中未找到该城市。',
  'onboarding.municipios.selected': '已选择',
  'onboarding.municipios.add': '添加',
  'onboarding.municipios.remove': '移除',
  'onboarding.municipios.count': '已选择 {count} 个城市。',
  'onboarding.municipios.save': '保存选择',
  'onboarding.municipios.update': '更新选择',
  'onboarding.municipios.saved': '选择已保存（{count} 个城市）。',
  'onboarding.thresholds.title': '验证阈值',
  'onboarding.thresholds.subtitle': 'VLM 最低置信度、自动批准和复核队列 —— 已预填默认值。',
  'onboarding.thresholds.save': '保存阈值',
  'onboarding.thresholds.saved': '阈值已保存。',
  'onboarding.tour.title': '界面导览',
  'onboarding.tour.subtitle': '交互式地了解系统的主要区域。',
  'onboarding.tour.start': '开始导览',
  'onboarding.tour.next': '下一步',
  'onboarding.tour.prev': '上一步',
  'onboarding.tour.skip': '跳过导览',
  'onboarding.tour.finish': '完成',
  'onboarding.tour.counter': '{current}/{total}',
  'onboarding.tour.step.intro.title': '欢迎使用 Aura Nota',
  'onboarding.tour.step.intro.body': '本次快速导览将展示主要区域：上传、文档、目录和设置。',
  'onboarding.tour.step.upload.title': '文档上传',
  'onboarding.tour.step.upload.body': '在此发送 NFS-e 和账单的 PDF、XML 与图片 —— 自动提取。',
  'onboarding.tour.step.documents.title': '文档',
  'onboarding.tour.step.documents.body': '所有捕获的文档都在这里，包含提取和复核状态。',
  'onboarding.tour.step.catalogo.title': '城市目录',
  'onboarding.tour.step.catalogo.body': '查看 城市 → NFS-e 服务商 覆盖情况，并建议新的映射。',
  'onboarding.tour.step.settings.title': '租户设置',
  'onboarding.tour.step.settings.body': '管理组织的用户、服务商、电子邮件、保留策略和阈值。',
  'onboarding.tour.step.done.title': '导览完成',
  'onboarding.tour.step.done.body': '完成！结束该步骤即可完成入门清单。',
  'onboarding.done.title': '入门引导完成！',
  'onboarding.done.body': '组织已配置完毕，可以开始捕获文档。',
  'onboarding.done.notified': '已通知 {count} 位合作伙伴。',
  'onboarding.done.goUpload': '发送第一个文档',
  'onboarding.done.goSettings': '打开设置',
};
